// SEC_COL_DEFAULTS — brief 84 band C, candidate C80.
// The section-collapse defaults both matter views initialise their secCol
// state from. CCV adds its three collective-only sections AT ITS CALL SITE
// (spread + extras), which is where 1b puts the difference. Key ORDER changes
// for CCV (its extras once sat mid-object) and is proven unobservable: the
// only consumer is a keyed accessor (`sCol = (k) => !!secCol[k]`); nothing
// iterates the object. Evaluated at import as a pure literal; each view still
// spreads a FRESH object per mount, so no state is shared and the initializer
// runs exactly where and when it always did.

export const SEC_COL_DEFAULTS = {
    info: true,
    parties: true,
    gendocs: false,
    collabRates: true,
    calculator: true,
    fin: true,
    cdd: true,
    confid: true,
    timeline: true,
    desc: false,
    agenda: false,
    tasks: false,
    stages: false,
    emails: false,
    time: false,
    // 186 B.8 [RULED 186 (12)] — the Notes section is CLOSED by default (and shows
    // its last row under the header while closed). Both views read this key as
    // `sCol("notes")` — confirmed the same string in CaseView and CCV.
    notes: true,
};
